import React from 'react';

import { BaseInputProps, StyledTextField } from './StyledTextField';

export interface TextInputProps extends BaseInputProps {
  /** Valor de texto o null */
  value: string | null;
  /** Callback cuando cambia el valor */
  onChange: (value: string | null) => void;
  /** Nombre del campo para formularios */
  name?: string;
  /** Tipo de input (default: 'text') */
  type?: 'text' | 'email' | 'password' | 'tel' | 'url';
  /** Número máximo de caracteres */
  maxLength?: number;
  /** Número mínimo de caracteres */
  minLength?: number;
  /** Patrón de validación (regex) */
  pattern?: string;
  /** Tamaño del input */
  size?: 'small' | 'medium';
  /** Múltiples líneas (textarea) */
  multiline?: boolean;
  /** Número de filas para textarea */
  rows?: number;
}

/**
 * Input de texto simple
 *
 * Características:
 * - Procesa valores como string | null
 * - Soporta diferentes tipos de input (text, email, password, etc.)
 * - Soporta textarea con multiline
 * - Mantiene el estilo consistente con otros inputs
 */
export const TextInput: React.FC<TextInputProps> = ({
  value,
  onChange,
  label,
  disabled = false,
  error = false,
  helperText,
  required = false,
  fullWidth = true,
  placeholder,
  name,
  type = 'text',
  maxLength,
  minLength,
  pattern,
  size = 'small',
  multiline = false,
  rows,
}) => {
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const newValue = e.target.value;
    onChange(newValue === '' ? null : newValue);
  };

  return (
    <StyledTextField
      type={type}
      value={value ?? ''}
      onChange={handleChange}
      label={label}
      disabled={disabled}
      error={error}
      helperText={helperText}
      required={required}
      fullWidth={fullWidth}
      placeholder={placeholder}
      name={name}
      size={size}
      multiline={multiline}
      rows={rows}
      inputProps={{
        maxLength,
        minLength,
        pattern,
      }}
    />
  );
};
